<template>
  <v-card class="progress-status border">
    <v-row class="px-5 py-7">
      <v-col cols="6">
        <!-- SMOKING BEHAVIOUR -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $ucfirst($t("smokeFreeLiving.smokingBehaviour")) }}</h3>
            <p v-if="showSmokingBehaviour" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ smokingBehaviourReportDate }}</p>
          </div>

          <v-row v-if="showSmokingBehaviour" align="center">
            <v-col cols="12">
              <table>
                <tr v-if="smokingBehaviourDetailsForm">
                  <td>
                    {{ $t("smokeFreeLiving.numberCigarettes") }}
                  </td>
                  <td class="pl-10">
                    {{ numberOfCigarettesMessage.quantity }}
                    {{ $t("questionnaires.SMOKING_DETAILS.CIGARETTES", "questionnaires") }}
                    {{ numberOfCigarettesMessage.interval }}
                  </td>
                </tr>
                <tr v-if="fagerstromForm">
                  <td>
                    {{ $t("smokeFreeLiving.fagerstromScore") }}
                  </td>
                  <td class="pl-10">
                    {{ fagerstromScore }} <span class="pl-2" :style="{color : fagerstromMessage.color}">{{ fagerstromMessage.message }}</span>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>


        <!-- QUIT ATTEMPTS BEFORE STUDY -->

        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $ucfirst($t("smokeFreeLiving.attemptsBeforeStudy")) }}</h3>
            <p v-if="showQuitAttemptsBeforeStudy" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ pastQuitAttemptsReportDate }}</p>
          </div>

          <v-row v-if="showQuitAttemptsBeforeStudy" align="center">
            <v-col cols="12">
              <table class="text-top">
                <tr>
                  <td>
                    {{ $t("smokeFreeLiving.numberQuitAttempts") }}
                  </td>
                  <td class="pl-10">
                    {{ numberOfQuitAttemptsBeforeStudy }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("smokeFreeLiving.mostRecentQuitAttempt") }}
                  </td>
                  <td class="pl-10">
                    {{ mostRecentQuitAttemptBeforeStudy ? mostRecentQuitAttemptBeforeStudy : '/' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("smokeFreeLiving.optionsQuit") }}
                  </td>
                  <td class="pl-10">
                    <ul v-if="numberOfQuitAttemptsBeforeStudy">
                      <li v-for="a in answersOptionsUsedBeforeStudy" v-bind:key="a.key">
                        <span v-if="a.key === 'OTHER'">{{ a.text }}: {{ otherAnswerOptionUsedBeforeStudy }}</span>
                        <span v-else>{{ a.text }}</span>
                      </li>
                    </ul>
                    <span v-else>/</span>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="6">
        <!-- MOTIVATION STOP SMOKING -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $ucfirst($t("smokeFreeLiving.motivationToStop")) }}</h3>
            <p v-if="showMotivationStopSmoking" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ motivationStopSmokingReportDate }}</p>
          </div>

          <v-row v-if="showMotivationStopSmoking" align="center">
            <v-col cols="12">
              {{ showMotivationStopSmokingAnswer }}
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- MOST RECENT QUIT ATTEMPTS DURING STUDY -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $ucfirst($t("smokeFreeLiving.mostRecentQuitAttemptDuringStudy")) }}</h3>
            <p v-if="showQuitAttemptDuringStudy" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ quitAttemptDuringStudyReportDate }}</p>
          </div>

          <v-row v-if="showQuitAttemptDuringStudy" align="center">
            <v-col cols="12">
              <table class="text-top">
                <tr>
                  <td>
                    {{ $t("smokeFreeLiving.quitDate") }} {{ quitAttemptDuringStudyQuitDate }}
                  </td>
                  <td class="pl-10 color-coro-green">
                    {{ quitAttemptDuringStudyQuitDays }} {{ $t("frequency.days") }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("smokeFreeLiving.optionsQuit") }}
                  </td>
                  <td class="pl-10">
                    <ul v-if="currentQuitForm">
                      <li v-for="a in answersOptionsUsedDuringStudy" v-bind:key="a.key">
                        <span v-if="a.key === 'OTHER'">{{ a.text }}: {{ otherAnswerOptionUsedDuringStudy }}</span>
                        <span v-else>{{ a.text }}</span>
                      </li>
                    </ul>
                    <span v-else>{{ $t("noData") }}</span>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import {mapGetters} from "vuex";
import moment from "moment";
import {getEntryWithQuestionKey} from "@/helper/questionnaires";
import gql from "graphql-tag";

export default {
  name: "PatientOverviewSmokingProgress",
  data: function() {
    return {
      smokingBehaviourForm : null,
      smokingBehaviourDetailsForm : null,
      fagerstromForm : null,
      pastQuitAttemptsForm : null,
      motivationStopSmokingForm : null,
      currentQuitAttempt: null,
      currentQuitForm: null,
    }
  },
  mounted: function() {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    isAnEproSmoker() {
      return ['SOMETIMES', 'CURRENTLY'].includes(
          getEntryWithQuestionKey(this.smokingBehaviourForm, 'DO_YOU_SMOKE_OR_HAVE_SMOKED')?.givenAnswers[0].key
      );
    },
    showSmokingBehaviour() {
      return (this.smokingBehaviourDetailsForm || this.fagerstromForm) && this.isAnEproSmoker;
    },
    smokingBehaviourReportDate() {
      const date1 = this.smokingBehaviourDetailsForm ? moment(this.smokingBehaviourDetailsForm.entryDate) : null;
      const date2 = this.fagerstromForm ? moment(this.fagerstromForm.entryDate) : null;
      let returnDate = null;

      if (date1 && date2) {
        returnDate = date1.isAfter(date2) ? date1 : date2;
      }else if(date1) {
        returnDate = date1
      }else if (date2) {
        returnDate = date2
      }

      return returnDate ? returnDate.format('DD/MM/YYYY') : null;
    },
    fagerstromScore() {
      return this.fagerstromForm !== null ? parseInt(this.fagerstromForm.score) : null;
    },
    numberOfCigarettesMessage() {
      const quantity = getEntryWithQuestionKey(this.smokingBehaviourDetailsForm, 'HOW_MANY'),
          interval = getEntryWithQuestionKey(this.smokingBehaviourDetailsForm, 'HOW_MANY_FREQUENCY');

      if (quantity && interval) {
        return {
          quantity: quantity.givenAnswers[0].openAnswer,
          interval: this.$t('questionnaires.SMOKING_DETAILS.frequency.' + interval.givenAnswers[0].key, 'questionnaires').toLowerCase()
        }
      }

      return { quantity : null , interval : null }
    },
    fagerstromMessage() {
      const score = this.fagerstromScore;

      if (score >= 8) {
        return { message : this.$t('fagerstrom.high'), color : this.$color.coro['status-darkred']}
      }else if (score >= 5) {
        return { message : this.$t('fagerstrom.moderate'), color : this.$color.coro['status-red']}
      }else if (score >= 3) {
        return { message : this.$t('fagerstrom.lowModerate'), color : this.$color.coro['status-orange']}
      }else {
        return { message : this.$t('fagerstrom.low'), color : this.$color.coro['status-yellow']}
      }
    },
    showQuitAttemptsBeforeStudy() {
      return this.pastQuitAttemptsForm;
    },
    pastQuitAttemptsReportDate() {
      return this.pastQuitAttemptsForm ? moment(this.pastQuitAttemptsForm.entryDate).format('DD/MM/YYYY') : null;
    },
    numberOfQuitAttemptsBeforeStudy() {
      const number = getEntryWithQuestionKey(this.pastQuitAttemptsForm, 'HOW_MANY_TIMES')?.givenAnswers[0]?.openAnswer
      return number !== null ? parseInt(number) : null;
    },
    mostRecentQuitAttemptBeforeStudy() {
      if (!this.numberOfQuitAttemptsBeforeStudy) {
        return null;
      }
      const date = getEntryWithQuestionKey(this.pastQuitAttemptsForm, 'WHEN_LAST_TIME')?.givenAnswers[0]?.openAnswer
      return date ? moment(date).format('D MMMM YYYY') : null;
    },
    answersOptionsUsedBeforeStudy () {
      if (this.pastQuitAttemptsForm) {
        return getEntryWithQuestionKey(this.pastQuitAttemptsForm, 'HOW_TRY_QUIT').givenAnswers;
      }

      return [];
    },
    otherAnswerOptionUsedBeforeStudy () {
      if (this.pastQuitAttemptsForm) {
        return getEntryWithQuestionKey(this.pastQuitAttemptsForm, 'OTHER').givenAnswers[0].openAnswer;
      }

      return '';
    },
    showMotivationStopSmoking () {
      return this.motivationStopSmokingForm && this.isAnEproSmoker;
    },
    motivationStopSmokingReportDate() {
      return this.motivationStopSmokingForm ? moment(this.motivationStopSmokingForm.entryDate).format('DD/MM/YYYY') : null;
    },
    showMotivationStopSmokingAnswer () {
      return getEntryWithQuestionKey(this.motivationStopSmokingForm, 'MOTIVATION')?.givenAnswers[0].text;
    },
    showQuitAttemptDuringStudy() {
      return !!this.currentQuitAttempt;
    },
    quitAttemptDuringStudyQuitDate() {
      return this.currentQuitAttempt ? moment(this.currentQuitAttempt.activateDate).format('D MMMM YYYY') : null;
    },
    quitAttemptDuringStudyReportDate() {
      return this.currentQuitAttempt ? moment(this.currentQuitAttempt.createdAt).format('DD/MM/YYYY') : null;
    },
    quitAttemptDuringStudyQuitDays() {
      return this.currentQuitAttempt ? parseInt(this.currentQuitAttempt.quitTimeDays) : null;
    },
    answersOptionsUsedDuringStudy () {
      if (this.currentQuitForm) {
        return getEntryWithQuestionKey(this.currentQuitForm, 'HOW_STOPPED').givenAnswers;
      }

      return [];
    },
    otherAnswerOptionUsedDuringStudy () {
      if (this.currentQuitForm) {
        return getEntryWithQuestionKey(this.currentQuitForm, 'OTHER').givenAnswers[0].openAnswer;
      }

      return '';
    },
  },
  methods : {
    loadData() {
      this.getSmokingBehaviourForm();
      this.getSmokingBehaviourDetailsForm();
      this.getFagerstromForm();
      this.getPastQuitAttemptsForm();
      this.getMotivationStopSmokingForm();
      this.getCurrentQuitForm();
      this.getCurrentOpenQuitAttempt();
    },
    async getSmokingBehaviourForm() {
      this.smokingBehaviourForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'SMOKINGBEHAVIOUR')
    },
    async getSmokingBehaviourDetailsForm() {
      this.smokingBehaviourDetailsForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'SMOKINGBEHAVIOURDETAILS')
    },
    async getFagerstromForm() {
      this.fagerstromForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'FAGERSTROM')
    },
    async getPastQuitAttemptsForm() {
      this.pastQuitAttemptsForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'PASTQUITATTEMPTS')
    },
    async getMotivationStopSmokingForm() {
      this.motivationStopSmokingForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'MOTIVATIONSTOPSMOKING')
    },
    async getCurrentQuitForm() {
      this.currentQuitForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'CURRENTQUIT')
    },
    async getCurrentOpenQuitAttempt() {
      const result = await this.$app.apolloMobileClient
          .query({
            query: gql`query myQuitAttempts($patientId : String!){
              myQuitAttempts(
                functions : {function : patientId, parameters : [$patientId]}
                conditions : {function : currentAttempt}
              ){
                id
                createdAt
                startDate
                activateDate
                quitTimeDays
              }
            }`
          , variables : {patientId : this.patientId}});

      if (result?.data?.myQuitAttempts?.length) {
        this.currentQuitAttempt = result.data.myQuitAttempts[0];
      }

      console.log(this.currentQuitAttempt)
    },
  },
  watch: {
    patientId: function () {
      this.loadData();
    },
  },
};
</script>

<style scoped>
.physical-activity-progress-status__reported-on {
  text-align: right;
}
</style>
